import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import { Vector2 } from 'three'

import { KVMessageDef } from './index'

export function getSelectPolygonMessage() {
  return {
    type: 'selectPolygon',
    requiredData: ['surfaceAreaId'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const targetId = json.surfaceAreaId as string
      const list = kv.annotations ?? []
      const annotation = list.find((a) => a.id === targetId)
      if (!annotation) return

      const kvElementRect = kv.videoParent.current?.getBoundingClientRect()
      if (kvElementRect) {
        const topRightX = kvElementRect.width - 475
        const topRightY = 20
        kv.setPopupMenuStartPosition(new Vector2(topRightX, topRightY))
      }

      kv.setSelectedMarkup(annotation)
    },
  } as KVMessageDef
}
